// CampaignManagementPage.jsx
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Plus, RefreshCw } from "lucide-react";

import CampaignTable from "../../components/Campaign/CampaignTable";
import {
  useCampaignList,
  useDeleteCampaign,
} from "../../features/capmpaign/useCampaigns";

const CampaignManagementPage = () => {
  const navigate = useNavigate();
  const [deletingSlug, setDeletingSlug] = useState(null);

  const {
    data: campaigns = [],
    isLoading,
    isError,
    refetch,
  } = useCampaignList();

  const deleteMutation = useDeleteCampaign();

  const handleDelete = async (campaign) => {
    const confirmed = window.confirm(
      `آیا از حذف رویداد «${campaign.title}» مطمئن هستید؟`
    );

    if (!confirmed) return;

    try {
      setDeletingSlug(campaign.slug);
      await deleteMutation.mutateAsync(campaign.slug);
    } finally {
      setDeletingSlug(null);
    }
  };

  return (
    <main dir="rtl" className="min-h-screen bg-gray-50 px-4 py-6 sm:px-6 lg:px-8">
      <div className="mx-auto w-full max-w-7xl">
        {/* هدر صفحه */}
        <div className="mb-5 flex flex-col gap-4 rounded-2xl border border-gray-200 bg-white p-4 shadow-sm sm:flex-row sm:items-center sm:justify-between sm:p-5">
          <div className="space-y-1">
            <h1 className="text-base font-semibold text-gray-900 sm:text-lg">
              مدیریت رویدادها
            </h1>
            <p className="text-sm text-gray-500">
              مشاهده، ویرایش و حذف رویدادهای ثبت‌شده
            </p>
          </div>

          <div className="flex flex-col gap-3 sm:flex-row sm:items-center">
            {/* دکمه secondary طبق سیستم طراحی */}
            <button
              type="button"
              onClick={() => refetch()}
              disabled={isLoading}
              className="inline-flex h-11 items-center justify-center gap-2 rounded-lg bg-[#F5F5F5] px-4 text-sm font-medium text-[#1E3A5F] transition-colors duration-200 hover:bg-[#DBDBDB] hover:text-[#12233A] focus:border-[#1E3A5F] focus:outline-none disabled:cursor-not-allowed disabled:opacity-50"
            >
              <RefreshCw className={`h-4 w-4 ${isLoading ? "animate-spin" : ""}`} />
              بروزرسانی
            </button>

            {/* دکمه primary طبق سیستم طراحی */}
            <button
              type="button"
              onClick={() => navigate("/admin-panel/campaigns/new")}
              className="inline-flex h-11 items-center justify-center gap-2 rounded-lg bg-[#1E3A5F] px-4 text-sm font-medium text-[#FFC107] transition-colors duration-200 hover:bg-[#2B5388] hover:text-[#D19D00] focus:border-[#1E3A5F] focus:outline-none"
            >
              <Plus className="h-4 w-4" />
              افزودن رویداد
            </button>
          </div>
        </div>

        {/* حالت لودینگ */}
        {isLoading && (
          <div className="rounded-2xl border border-gray-200 bg-white p-8 text-center shadow-sm">
            <div className="mx-auto mb-3 h-6 w-6 animate-spin rounded-full border-2 border-gray-300 border-t-[#1E3A5F]" />
            <p className="text-sm text-gray-600">در حال دریافت رویدادها...</p>
          </div>
        )}

        {/* حالت خطا */}
        {isError && (
          <div className="rounded-2xl border border-red-200 bg-red-50 p-5 shadow-sm">
            <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
              <div>
                <p className="text-sm font-medium text-red-700">
                  دریافت اطلاعات با خطا مواجه شد.
                </p>
                <p className="mt-1 text-sm text-red-600">
                  لطفاً دوباره تلاش کنید.
                </p>
              </div>

              {/* دکمه danger طبق سیستم طراحی */}
              <button
                type="button"
                onClick={() => refetch()}
                className="inline-flex h-11 items-center justify-center gap-2 rounded-lg bg-[#E74C3C] px-4 text-sm font-medium text-white transition-colors duration-200 hover:bg-[#C0392B] hover:text-[#F8F8F8] focus:border-[#1E3A5F] focus:outline-none"
              >
                <RefreshCw className="h-4 w-4" />
                تلاش مجدد
              </button>
            </div>
          </div>
        )}

        {/* جدول */}
        {!isLoading && !isError && (
          <CampaignTable
            campaigns={campaigns}
            onDelete={handleDelete}
            deletingSlug={deletingSlug}
          />
        )}
      </div>
    </main>
  );
};

export default CampaignManagementPage;